/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IReturnsData } from './returns.data';
import { IReturnsProps } from './returns.props.autogenerated';

export interface IReturnsViewProps extends IReturnsProps<IReturnsData> {
    hideReCaptcha: boolean;
}

/**
 *
 * Returns component
 * @extends {React.PureComponent<IReturnsProps<IReturnsData>>}
 */
class Returns extends React.PureComponent<IReturnsProps<IReturnsData>> {
    public render(): JSX.Element | null {
        const viewProps: IReturnsViewProps = {
            ...this.props,
            hideReCaptcha: this.props.config.hideReCaptcha || false
        };
        return this.props.renderView(viewProps);
    }
}

export default Returns;
